var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import useEmotionStyles from '../../hooks/useEmotionStyles';
var getColor = function (theme, _a) {
    var hasError = _a.hasError, isChecked = _a.isChecked, isDisabled = _a.isDisabled;
    if (isDisabled) {
        return theme.palette.grey[100];
    }
    if (hasError) {
        return theme.palette.error.main;
    }
    if (isChecked) {
        return theme.palette.primary.main;
    }
    return theme.palette.grey[700];
};
var styles = function (theme, _a) {
    var hasError = _a.hasError, isChecked = _a.isChecked, isDisabled = _a.isDisabled;
    return ({
        checkbox: {
            '& svg': {
                color: getColor(theme, { hasError: hasError, isChecked: isChecked, isDisabled: isDisabled }),
            },
        },
        formLabel: {
            '& > span': {
                fontSize: theme.typography.body1.fontSize,
                paddingTop: 0,
                alignSelf: 'flex-start',
            },
        },
    });
};
var SingleCheckbox = function (props) {
    var label = props.label, error = props.error, propsToPass = __rest(props, ["label", "error"]);
    var _a = useEmotionStyles(styles, {
        hasError: !!error,
        isChecked: !!propsToPass.checked,
        isDisabled: !!propsToPass.disabled,
    }), checkbox = _a.checkbox, formLabel = _a.formLabel;
    return (React.createElement(FormControlLabel, { className: formLabel, control: React.createElement(Checkbox, __assign({}, propsToPass, { className: checkbox, color: "primary" })), label: label }));
};
export default SingleCheckbox;
